export { default } from './EditStripsPopup';
